module.exports = __webpack_public_path__ + "static/screenie_usage_1-593c4fcb8059042a3864256d731d8419.mp4";